import { Field, Widget } from '@kanda-libs/ks-component-ts';

import { MORTGAGE_VALIDATION, RESIDENTIAL_PROPS } from './constants';
import useResidentialFields from './useResidentialFields';

const ResidentialFields: React.FunctionComponent = function () {
  const { showRent, showMortgage } = useResidentialFields();
  return (
    <div className="flex flex-col gap-x-3 md:gap-x-4">
      <Widget.CreditCustomerDetailsResidentialStatus
        {...RESIDENTIAL_PROPS.residentialStatusProps}
      />
      {showRent && (
        <Widget.CreditCustomerDetailsMonthlyRentAmountAmount
          {...RESIDENTIAL_PROPS.monthlyRentProps}
        />
      )}
      {showMortgage && (
        <Field.Validator validation={MORTGAGE_VALIDATION}>
          <Field.NumberInput {...RESIDENTIAL_PROPS.monthlyMortgageProps} />
        </Field.Validator>
      )}
    </div>
  );
};

export default ResidentialFields;
